import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { PATHS } from '../../../shared/config/paths'

type Props = {
  /** Current topic title; omitted on the hub. */
  crumb?: string
  children: ReactNode
}

/** `body` is `overflow: hidden; height: 100dvh` app-wide, so the guide scrolls inside its own root. */
export const GuideLayout = ({ crumb, children }: Props) => (
  <div className="h-[100dvh] overflow-y-auto bg-bg">
    <header className="border-b border-gray-200 bg-white">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
        <Link to={PATHS.userGuide}>
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="WGH Herrenhausen" className="h-12" />
        </Link>
        <Link
          to={PATHS.login}
          className="rounded-full bg-primary px-5 py-2 text-base font-bold text-white transition-opacity hover:opacity-90"
        >
          Zur Anmeldung
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-4xl px-4 py-8">
      {crumb && (
        <nav aria-label="Brotkrumen" className="mb-4 flex items-center gap-1 text-[15px] text-gray-500">
          <Link to={PATHS.userGuide} className="text-primary hover:underline">
            Anleitung
          </Link>
          <ChevronRight size={14} aria-hidden />
          <span>{crumb}</span>
        </nav>
      )}
      {children}
    </main>
  </div>
)
